var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vendor logos / Visa"
  }, /*#__PURE__*/React.createElement("g", {
    id: "base / logos / ecomm / visa"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7181 23.1528C37.7284 20.6074 35.6859 19.501 34.0517 18.6158C32.9546 18.0215 32.0415 17.5269 32.0573 16.7634C32.0695 16.185 32.6042 15.57 33.7711 15.4128C34.3501 15.3346 35.9452 15.2749 37.7556 16.1342L38.4653 12.716C37.4913 12.3494 36.2405 12 34.6842 12C30.6906 12 27.8801 14.1912 27.8564 17.3287C27.8304 19.6494 29.8617 20.9444 31.393 21.7156C32.9677 22.5053 33.4961 23.0127 33.4901 23.7191C33.4789 24.8007 32.2344 25.2781 31.0708 25.2966C29.104 25.3278 27.9375 24.7669 27.0125 24.3221L26.9223 24.2787L26.19 27.8103C27.134 28.2573 28.8765 28.6473 30.6833 28.6667C34.9282 28.6667 37.7046 26.5029 37.7176 23.1514L37.7181 23.1528ZM20.9836 12.2957L14.437 28.4148H10.1661L6.94466 15.5499C6.74908 14.7575 6.58007 14.4675 5.98448 14.1336C5.01336 13.5896 3.40967 13.0797 2 12.7628L2.09453 12.2957H8.96971C9.84604 12.2957 10.6338 12.898 10.8328 13.9396L12.5341 23.2665L16.7387 12.2957H20.9836ZM52 28.4148H48.2632L47.7741 26.0068H42.5917L41.7492 28.4148H37.5067L43.5704 13.4783C43.8543 12.7578 44.5355 12.2891 45.2891 12.2957H48.7382L52 28.4148ZM43.755 22.7028L45.8816 16.65L47.1056 22.7026L43.755 22.7028ZM23.4151 28.4148L26.7561 12.2957H22.7172L19.3749 28.4148H23.4151Z",
    fill: "#1434CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.c710f725c845b2dddbea72bde1790b9d.svg";
export { ForwardRef as ReactComponent };